// @flow
import * as React from "react";

import { Button, Space } from "antd";

import Navigation from "../Navigation";
import ProfileLink from "../ProfileLink";

import AuthService from "services/auth";

const Navbar = {
  LoggedIn(): React.Node {
    const claims = AuthService.getClaims();

    const handleLogout = () => {
      AuthService.logout();

      window.location.replace(`${process.env.REACT_APP_MAIN_SITE_ORIGIN}/login`);
    };

    return (
      <>
        <ul className="navbar-nav nav-pills">
          <Navigation claims={claims} />
        </ul>
        <div className="d-flex align-items-center flex-nowrap ms-auto">
          <Space>
            <ProfileLink claims={claims} />
            <Button onClick={handleLogout}>Log out</Button>
          </Space>
        </div>
      </>
    );
  },
  LoggedOut(): React.Node {
    return (
      <div className="ms-auto">
        <Space>
          <Button href="/login">Log in</Button>
          <Button href="/signup" color="primary" variant="solid">
            Sign up
          </Button>
        </Space>
      </div>
    );
  },
};

export default Navbar;
